import EventHandler from '@pixelunion/events';
import debounce from 'just-debounce';

export default class QuantitySelector {
  constructor({ quantityField, onChange }) {
    this.events = new EventHandler();
    this.field = quantityField;
    this.input = this.field.querySelector('[data-quantity-input]');
    this.plus = this.field.querySelector('[data-quantity-plus]');
    this.minus = this.field.querySelector('[data-quantity-minus]');
    // this.max assigned in methods when max attribute has been added to the input
    this.min = this.input.min ? parseInt(this.input.min, 10) : 0;

    this.increaseAmount = this.increaseAmount.bind(this);
    this.decreaseAmount = this.decreaseAmount.bind(this);
    this.refreshQuantity = this.refreshQuantity.bind(this);

    this.onChange = onChange ? debounce(onChange, 1000) : () => {};

    this.events.register(this.plus, 'click', e => this.increaseAmount(e));
    this.events.register(this.minus, 'click', e => this.decreaseAmount(e));
    this.events.register(this.input, 'change', e => this.setAmount(e));
  }

  setAmount(e) {
    e.preventDefault();

    const currentValue = this.input.valueAsNumber;

    this.max = parseInt(this.input.max, 10);

    this.refreshQuantity();

    if (currentValue < this.max || currentValue > this.min) {
      this.onChange();
    }
  }

  increaseAmount(e) {
    e.preventDefault();

    const currentValue = this.input.valueAsNumber;
    this.max = parseInt(this.input.max, 10);
    if (!this.max || currentValue < this.max) {
      this.input.value = currentValue + 1;

      this.onChange();
    }
  }

  decreaseAmount(e) {
    e.preventDefault();
    const currentValue = this.input.valueAsNumber;
    if (currentValue > this.min) {
      this.input.value = currentValue - 1;

      this.onChange();
    }
  }

  refreshQuantity() {
    const currentValue = this.input.valueAsNumber;

    this.max = parseInt(this.input.max, 10);

    if (currentValue > this.max) {
      this.input.value = this.max;
    }
  }

  unload() {
    this.events.unregisterAll();
  }
}
